import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { ResponseError } from "@Front-end/seed/utils/interfaces";
import { TranslateService } from "@ngx-translate/core";
import { format } from "date-fns";
import {
    Observable,
    throwError,
} from "rxjs";
import {
    catchError,
    map,
} from "rxjs/operators";

export const localizeErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const translateService: TranslateService = inject(TranslateService);
    const translateError = (error: ResponseError): ResponseError => {
        const codeStr: string = error.code.toString();
        const messageStr: string = error.code.toString() === "5000046"
            ? format(new Date(error.message), "yyyy-MM-dd HH:mm:ss")
            : error.message.toString();
        return {
            code: error.code,
            message: translateService.instant("bff-errors." + codeStr, { value: messageStr }),
        };
    };

    return next(req).pipe(
        map((event) => {
            if (
                event instanceof HttpResponse
                && event.status === 200
                && (event?.body as { error: ResponseError })?.error
                && "code" in (event?.body as { error: ResponseError }).error
            ) {
                const translatedError: ResponseError = translateError((event.body as { error: ResponseError }).error);
                event = event.clone({ body: { error: translatedError } });
            }

            return event;
        }),
        catchError((error: HttpErrorResponse): Observable<never> => throwError(() => error)),
    );
};
